/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : ProjectAccess.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
/**
 * @author : Narender - narender@au79consulting.com
 * @Date : 23-09-2024
 * @description: To give co-owner/editor/viewer access to the project/zones/ee component/software module
 */
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  CustomTextFieldN,
  SearchSelectProjectTextField,
} from "../../components";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

import NewRequestTab from "./project-access/NewRequestTab";
import PendingRequestsTab from "./project-access/PendingRequestsTab";
import AccessControlTab from "./project-access/AccessControlTab";

import selectProjectAction from "../../redux/actions/selectProject";
import { useLocation } from "react-router-dom";
import CommonBreadcrumbs from "../../components/customComponentsV2/common/Breadcrumbs/CommonBreadcrumbs";
import CustomTabsV2 from "../../components/customComponentsV2/common/tabs/CustomTabsV2";

import { convertUtcToTimeZone } from "../../utils/convertUtcToTimeZone";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import appTheme from "../../assets/AppTheme/appTheme";
import CloseIcon from "@mui/icons-material/Close";
import CustomButtonV2 from "../../components/customComponentsV2/common/button/CustomButtonV2";
import {
  HandleApiActions,
  labCar,
  userManagementApis,
} from "../../redux/actions";
import CustomDialogBoxV2 from "../../components/customComponentsV2/common/customDialogBox/CustomDialogBoxV2";
function ProjectAccess() {
  const moduleTypes = {
    PROJECT: "PROJECT",
    VARIANT: "VARIANT",
    EE: "EE",
    SWM: "SWM",
    VEHICLE_SYSTEM: "VS",
    VEHICLE_COMPONENT: "VC",
  };
  const accessTypes = { COOWNER: "OWNER", EDITOR: "EDITOR", VIEWER: "VIEWER" };

  //Profile details
  const profileDetails = useSelector((store) => store.profileReducer);

  const dispatch = useDispatch();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const tabFromUrl = queryParams.get("tab");
  const typeFromUrl = queryParams.get("type");

  /* useSelectors */
  const [requestsTableRowsData, setRequestsTableRowsData] = useState([]);
  const [requestAccessList, setRequestAccessList] = useState([]);
  const [page] = useState(1);
  const [rowsPerPage] = useState(25);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [usersDetail, setUsersDetail] = useState(new Map());
  const [openApproveAccessDialog, setOpenApproveAccessDialog] = useState(false);

  const [reasonToApproveAccess, setReasonToApproveAccess] = useState("");

  const selectedProject = useSelector(
    (state) => state?.projectConfigReducer?.selectedProjectDetails,
  );

  const {
    project_status,
    access_module_types,
    access_request_types,
    access_request_status,
  } = useSelector((state) => state?.settingsReducer?.metaData, shallowEqual);

  /* Project-related state variables */
  const [projectOptionsList, setProjectOptionsList] = useState([]);

  // Project access tabs state
  const [selectedPaTab, setSelectedPaTab] = useState(0);

  useEffect(() => {
    if (tabFromUrl === "AC") {
      setSelectedPaTab(2);
    }
  }, [tabFromUrl]);
  const [userDetailsMap, setUserDetailsMap] = useState([]);
  const [openForwardApproveAccessDialog, setOpenForwardApproveAccessDialog] =
    useState(false);
  const [selectedApproveAccessData, setSelectedApproveAccessData] =
    useState(null);

  const [selectedRejectAccessData, setSelectedRejectAccessData] =
    useState(null);
  const [reasonToRejectAccess, setReasonToRejectAccess] = useState("");
  const [openRejectAccessDialog, setOpenRejectAccessDialog] = useState(false);
  const [triggerFetchUser, setTriggerFetchUser] = useState(true);
  /* UseEffects */
  useEffect(() => {
    // Get the project details
    dispatch(
      HandleApiActions({
        ...labCar.get_project_details,
        params: {
          page_number: 1,
          page_size: 10000,
          sort_column: "created_at",
          sort_order: "DESC",
        },
      }),
    );
  }, []);
  const fetchUserDetails = async () => {
    try {
      const apiDetails = userManagementApis?.get_users_list_pa;
      delete apiDetails.action_type;
      const resp = await dispatch(
        HandleApiActions({
          ...apiDetails,
          params: {
            page_size: 100,
            page_number: 1,
          },

          show_toast: false,
        }),
      );
      console.log("----resp----", resp);

      if (!resp.error) {
        const users = resp?.data || [];

        console.log("---userMap---", users);
        setUserDetailsMap(users);
        setUsersDetail(users);
      }
    } catch (error) {
      console.error("Failed to fetch user details:", error);
    }
  };

  // useEffect(() => {
  //   // Project options list
  //   let filteredProjectOptionsList = projectDetails
  //     ?.map((el) => {
  //       return {
  //         value: el?.project_id,
  //         label: el?.name,
  //       };
  //     })
  //     ?.sort((a, b) => a.label.localeCompare(b.label));

  //   /* Select first project by default */
  //   if (!selectedProject && filteredProjectOptionsList.length) {
  //     dispatch(selectProjectAction(filteredProjectOptionsList[0]));
  //   }
  // }, [projectDetails]);

  // useEffect(() => {
  //   /* Update selected project details based on the selected project */
  //   if (selectedProject) {
  //     let filteredSelectedProjectDetails = projectDetails?.find(
  //       (el) => el?.project_id == selectedProject?.value
  //     );

  //     setSelectedProjectDetails(filteredSelectedProjectDetails);
  //   }
  // }, [selectedProject]);


  const getRequestAccessList = async () => {
    let apiDetails = userManagementApis.get_forward_access;

    const resp = await dispatch(
      HandleApiActions({
        ...apiDetails,
        show_toast: false,
      }),
    );
    if (resp.error) {
      setRequestAccessList([]);
    } else {
      setRequestAccessList(resp?.data);
    }
  };

  useEffect(() => {
    getRequestAccessList();
  }, [triggerFetchUser]);
  const handleApproveAccessClick = (params) => {
    console.log("parassms", params);
    setSelectedApproveAccessData(params?.access_request_id);
    setOpenApproveAccessDialog(true);
  };
  const handleRejectAccessClick = (params) => {
    setSelectedRejectAccessData(params?.access_request_id);
    setOpenRejectAccessDialog(true);
  };

  const handleConfirmRejectAccess = () => {
    rejectForwardAccess(selectedRejectAccessData);
    setTimeout(() => {
      getRequestAccessList();
    }, 500);
    setOpenRejectAccessDialog(false);
    setSelectedRejectAccessData(null);
    setReasonToRejectAccess("");
  };

  const handleCancelRejectAccess = () => {
    setOpenRejectAccessDialog(false);
    setReasonToRejectAccess("");
  };

  const handleConfirmApproveAccess = () => {
    approveForwardAccess(selectedApproveAccessData);
    setTimeout(() => {
      getRequestAccessList();
    }, 500);
    setOpenApproveAccessDialog(false);
    setSelectedApproveAccessData(null);
    setReasonToApproveAccess("");
  };
  const getValueByKey = (array, key) => {
    const result = array.find((item) => item.key === key);
    return result ? result.value : "-";
  };

  const approveForwardAccess = async (access_request_id) => {


    let apiDetails = userManagementApis.approve_forward_access;
    const resp = await dispatch(
      HandleApiActions({
        ...apiDetails,
        params: {
          access_request_id: access_request_id,
          update_reason: reasonToApproveAccess,
        },
        show_toast: true,
      }),
    );
  };

  const rejectForwardAccess = async (access_request_id) => {
    let apiDetails = userManagementApis.reject_forward_access;
    const resp = await dispatch(
      HandleApiActions({
        ...apiDetails,
        params: {
          access_request_id: access_request_id,
          update_reason: reasonToRejectAccess,
        },
        show_toast: true,
      }),
    );
  };

  useEffect(() => {
    console.log("---requestAccessList---", requestAccessList);
    let filteredRequestsList = requestAccessList?.map((req, index) => {
      return {
        id: (page - 1) * rowsPerPage + index + 1,
        sNo: (page - 1) * rowsPerPage + index + 1,
        access_request_id: req?.access_request_id,
        requested_by: req?.requested_by,
        requested_for: req?.requested_for,
        status: getValueByKey(access_request_status, req?.status),
        forward_reason: req?.forward_reason,
        forwarded_at: convertUtcToTimeZone(
          req?.forwarded_at,
          profileDetails?.profile?.profile?.region,
        ),
        feature_details: req?.feature_details,
        page_details: req?.page_details,
        ...req,
      };
    });

    setRequestsTableRowsData(filteredRequestsList);
  }, [requestAccessList]);


  const requestsCOLUMNS = [
    {
      field: "sNo",
      headerName: "S.No",
      flex: 0.4,
      minWidth: 60,
      maxWidth: 80,
      filterable: false,
      sortable: false,
    },
    {
      field: "requested_by",
      headerName: "Requested By",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => {
        console.log("params------", params);
        const userId = params?.row?.requested_by;
        const userDetails = userDetailsMap?.find((u) => u?.user_id === userId); // ✔ single object

        return (
          <Box>
            <Typography variant="subtitle2">
              {userDetails?.fullname ?? userId ?? "-"}
            </Typography>
            <Typography variant="caption">
              {userDetails?.email ?? ""}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "requested_for",
      headerName: "Requested For",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => {
        const userId = params?.row?.requested_for;
        console.log("-----userId------", userId);
        const userDetails = userDetailsMap?.find((u) => u?.user_id === userId);

        return (
          <Typography variant="subtitle2">
            {userDetails?.fullname ?? userId ?? "-"}
          </Typography>
        );
      },
    },
    { field: "status", headerName: "Status", flex: 1, minWidth: 120 },
    {
      field: "forward_reason",
      headerName: "Request Reason",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => (
        <Typography>{params.row.forward_reason ?? "-"}</Typography>
      ),
    },
    {
      field: "details",
      headerName: "Details",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => (
        <Box>
          <CustomButtonV2
            size="small"
            variant="contained"
            btnName="View"
            handleOnClick={() => {
              setSelectedRowData(params?.row);
              setOpenForwardApproveAccessDialog(true);
            }}
          />
        </Box>
      ),
    },
    {
      field: "forwarded_at",
      headerName: "Requested At",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => (
        <Typography>{params.row.forwarded_at ?? "-"}</Typography>
      ),
    },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      minWidth: 120,
      renderCell: (params) =>
        params?.row?.status === "FORWARDED" ? (
          <Box>
            <IconButton
              size="small"
              color="success"
              onClick={() => handleApproveAccessClick(params?.row)}
            >
              <CheckCircleIcon />
            </IconButton>
            <IconButton
              size="small"
              color="error"
              onClick={() => handleRejectAccessClick(params?.row)}
            >
              <CancelIcon />
            </IconButton>
          </Box>
        ) : (
          "-"
        ),
    },
  ];
  useEffect(() => {
    fetchUserDetails();
  }, [rowsPerPage, page, triggerFetchUser]);

  const handleCloseApproveAccessDialog = () => {
    setOpenForwardApproveAccessDialog(false);
  };

  const handleCancelApproveAccess = () => {
    setOpenApproveAccessDialog(false);
    setReasonToApproveAccess("");
  };

  const handleRequestsTableRowClick = ({ params }) => {};

  const breadcrumbItems = [
    { label: "Settings" },
    { label: "Accounts & Access" },
    { label: "Project Management" },
  ];

  const tabsDataUsersPC = [
    {
      name: "Project Details",
      count: "",
      content: (
        <Box>
          {/* <Box sx={styles.spContainer}> */}
          <Box sx={{ display: "inline-block" }}>
            <SearchSelectProjectTextField
              txtFldStyle={styles.searchSelectTextField}
            />
          </Box>
          {/* </Box> */}
          <Box
            sx={{
              maxHeight: 500,
              overflowY: "visible",
              overflowX: "visible",
            }}
          >
            <NewRequestTab
              selectedProjectDetails={selectedProject}
              projectStatus={project_status}
              moduleTypes={moduleTypes}
              accessTypes={accessTypes}
            />
          </Box>
        </Box>
      ),
    },
    {
      name: "Project Request",
      count: "",

      content: (
        <Box>
          <Box sx={styles.spContainer}>
            <Box sx={{ display: "inline-block" }}>
              <SearchSelectProjectTextField
                txtFldStyle={styles.searchSelectTextField}
              />
            </Box>
          </Box>
          <Box sx={{ mt: 1 }}>
            <PendingRequestsTab
              selectedProjectDetails={selectedProject}
              moduleTypes={moduleTypes}
              accessModuleTypes={access_module_types}
              accessRequestTypes={access_request_types}
              accessRequestStatus={access_request_status}
            />
          </Box>
        </Box>
      ),
    },
    // {
    //   name: "Project Feature Access",
    //   count: "",
    //   content: (
    //     <Box>
    //       <Box sx={{ p: 1 }}>
    //         <Box sx={{ display: "flex" }}>
    //           {/* <CustomFilterV2
    //             // anchorEl={anchorElFilter}
    //             // open={openFilter}
    //             widthPerColumn="250px"
    //             // handleClick={handlePCFilterIconClick}
    //             // handleClose={handlePCFilterIconClosePC}
    //             // handleFilterButton={handleApplyFiltersPC}
    //             // showClearAll={true}
    //             // handleClearAll={() => handleApplyFiltersPC("discard")}
    //             sections={[
    //               {
    //                 heading: "Sorting",
    //                 content:
    //                   // <Box sx={{ p: 2 }}>
    //                   //   <CustomRadioButtonV2
    //                   //     value={filtersPC.sortBy}
    //                   //     onChange={(e) =>
    //                   //       setFiltersPC((prev) => ({
    //                   //         ...prev,
    //                   //         sortBy: e.target.value,
    //                   //       }))
    //                   //     }
    //                   //     data={[
    //                   //       { value: "created_at", label: "Created at" },
    //                   //       { value: "updated_at", label: "Updated at" },
    //                   //     ]}
    //                   //   />

    //                   //   <Box
    //                   //     sx={{
    //                   //       display: "flex",
    //                   //       flexDirection: "column",
    //                   //       mt: 2,
    //                   //     }}
    //                   //   >
    //                   //     <CustomCheckBoxV2
    //                   //       label="Sort Asc — Des"
    //                   //       value={filtersPC.sortOrder === "ASC"}
    //                   //       onChange={() =>
    //                   //         setFiltersPC((prev) => ({
    //                   //           ...prev,
    //                   //           sortOrder: "ASC",
    //                   //         }))
    //                   //       }
    //                   //     />
    //                   //     <CustomCheckBoxV2
    //                   //       label="Sort Des — Asc"
    //                   //       value={filtersPC.sortOrder === "DESC"}
    //                   //       onChange={() =>
    //                   //         setFiltersPC((prev) => ({
    //                   //           ...prev,
    //                   //           sortOrder: "DESC",
    //                   //         }))
    //                   //       }
    //                   //     />
    //                   //   </Box>
    //                   // </Box>
    //                   "sort",
    //               },

    //               {
    //                 heading: "Filter By Role Type",
    //                 content:
    //                   // <Box
    //                   //   sx={{ display: "flex", flexDirection: "column", mt: 2 }}
    //                   // >
    //                   //   {["ALL", ...atFilter].map((item) => {
    //                   //     console.log("---filtersPC---", filtersPC);
    //                   //     const checked =
    //                   //       (item === "ALL" && filtersPC.at_all) ||
    //                   //       (item === "CENTRALIZED" &&
    //                   //         filtersPC.doubleGroup.CENTRALIZED) ||
    //                   //       (item === "ZONAL" && filtersPC.doubleGroup.ZONAL);

    //                   //     return (
    //                   //       <CustomCheckBoxV2
    //                   //         key={item}
    //                   //         label={
    //                   //           item.charAt(0).toUpperCase() +
    //                   //           item.slice(1).toLowerCase()
    //                   //         }
    //                   //         value={checked}
    //                   //         onChange={(e) => {
    //                   //           const state = e.target.checked;
    //                   //           toggleArchitecture(item, state);
    //                   //         }}
    //                   //       />
    //                   //     );
    //                   //   })}
    //                   // </Box>
    //                   "Hello",
    //               },

    //               // ================= STATUS GROUP (SINGLE SELECT) =================
    //               {
    //                 heading: "Filter By Active",
    //                 content:
    //                   // <Box
    //                   //   sx={{ display: "flex", flexDirection: "column", mt: 2 }}
    //                   // >
    //                   //   {[
    //                   //     "ALL",
    //                   //     "ACTIVE PRE SOP",
    //                   //     "ACTIVE POST SOP",
    //                   //     "DRAFT",
    //                   //     "DEACTIVATED",
    //                   //     "COMPLETED",
    //                   //   ].map((item) => {
    //                   //     const value = singleValueMap[item];
    //                   //     const checked =
    //                   //       (item === "ALL" && filtersPC.ps_all) ||
    //                   //       filtersPC.statusGroup.includes(value);

    //                   //     return (
    //                   //       <CustomCheckBoxV2
    //                   //         key={item}
    //                   //         label={formatLabel(item)}
    //                   //         value={checked}
    //                   //         onChange={(e) => {
    //                   //           const state = e.target.checked;
    //                   //           toggleStatus(item, state);
    //                   //         }}
    //                   //       />
    //                   //     );
    //                   //   })}
    //                   // </Box>
    //                   "Hello",
    //               },
    //             ]}
    //           /> */}
    //           {/* <Box sx={{ ml: 2, mt: 0.3 }}>
    //           <CustomSearchbarWithApiV2
    //             // apiAction={{ ...projectConfigAPI.get_project }}
    //             params={{
    //               // page_number: pagePC,
    //               // page_size: rowsPerPagePC,
    //               // order_by_sort: filtersPC.sortOrder,
    //               // order_by_column: filtersPC.sortBy,
    //               order_by_sort: "ASC",
    //               order_by_column: "created_at",
    //             }}
    //             searchKey="name"
    //             size="small"
    //             type="text"
    //             variant="outlined"
    //             placeholder="Search Project Request..."
    //             valueError={""}
    //             isMultiline={false}
    //             minRows={1}
    //             maxRows={3}
    //             disabled={false}
    //             txtFldStyle={{
    //               width: "100%",
    //             }}
    //             getDataOnSearch={(data, resp) => {
    //               console.log("Search datadata", data);
    //               // setTotalCountPC(resp?.total_count);
    //               // setAllProjectDetails(data);
    //             }}
    //           />
    //         </Box> */}
    //         </Box>
    //         <Box>
    //           <Box
    //             sx={{
    //               height: "76vh",
    //               width: "100%",
    //               display: "flex",
    //               flexDirection: "column",

    //               mt: 1,
    //             }}
    //           >
    //             <CustomDataGridV2
    //               rows={requestsTableRowsData}
    //               columns={requestsCOLUMNS}
    //               onRowClick={handleRequestsTableRowClick}
    //               isMultiLine={true}
    //               rowsPerPage={rowsPerPage}
    //               totalItems={7}
    //               showPagination={true}
    //               handlePageChange={(newPage) => setPage(newPage)}
    //               page={page}
    //             />
    //           </Box>
    //         </Box>
    //       </Box>
    //     </Box>
    //   ),
    // },
    {
      name: "Access Control",
      count: "",

      content: (
        <Box>
          <Box sx={styles.spContainer}>
            <Box sx={{ display: "inline-block" }}>
              <SearchSelectProjectTextField
                txtFldStyle={styles.searchSelectTextField}
              />
            </Box>
          </Box>
          <Box sx={{ mt: 1 }}>
            <AccessControlTab
              selectedProjectDetails={selectedProject}
              projectStatus={project_status}
              moduleTypes={moduleTypes}
              accessTypes={accessTypes}
            />
          </Box>
        </Box>
      ),
    },
  ];

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        width: "100%",
        flexDirection: "column",

        // backgroundColor: "#f5f5f5",
      }}
    >
      <Box sx={{ m: 1 }}>
        <CommonBreadcrumbs items={breadcrumbItems} />
      </Box>

      <Box sx={{ mt: 1, ...styles.spContainer }}>
        <CustomTabsV2
          onTabChange={(tabValue) => {
            console.log("----tabValue----");
            console.log(tabValue);
            if (tabValue === 2) {
              setTriggerFetchUser((prev) => !prev);
            }
          }}
          tabs={tabsDataUsersPC}
          setTriggerFetchUser={setTriggerFetchUser}
        />
      </Box>

      <CustomDialogBoxV2
        open={openApproveAccessDialog}
        onClose={handleCancelApproveAccess}
        title={"Approve Access"}
        successButtonName={"Ok"}
        rejectButtonName={"Cancel"}
        onClickSuccess={handleConfirmApproveAccess}
        onClickReject={handleCancelApproveAccess}
        onConfirm={handleConfirmApproveAccess}
        actionButtonStyle={"continuous"}
      >
        <Stack spacing={1.2}>
          <DialogContentText>
            Are you sure you want to approve access?
          </DialogContentText>
          <Box>
            <CustomTextFieldN
              size={"small"}
              placeholder={"Reason to approve access*"}
              type={"text"}
              value={reasonToApproveAccess}
              setValue={setReasonToApproveAccess}
              // valueError={assemblyNoError}
              setValueError={() => null}
              variant={"standard"}
              txtFldStyle={styles.txtStyle}
            />
          </Box>
        </Stack>
      </CustomDialogBoxV2>
      {/* <CustomConfirmationDialog
        open={openRejectAccessDialog}
        onClose={handleCancelRejectAccess}
        dialogTitle={"Reject Access"}
        disableConfirmBtn={reasonToRejectAccess?.length < 5}
        dialogContent={
          <Stack spacing={1.2}>
            <DialogContentText>
              Are you sure you want to reject access?
            </DialogContentText>
            <Box>
              <CustomTextFieldN
                size={"small"}
                // label={"Reason*"}
                placeholder={"Reason to reject access*"}
                type={"text"}
                // fldType={"text"}
                value={reasonToRejectAccess}
                setValue={setReasonToRejectAccess}
                // valueError={assemblyNoError}
                setValueError={() => null}
                variant={"standard"}
                txtFldStyle={styles.txtStyle}
              />
            </Box>
          </Stack>
        }
        onConfirm={handleConfirmRejectAccess}
      /> */}

      <CustomDialogBoxV2
        open={openRejectAccessDialog}
        onClose={handleCancelRejectAccess}
        title={"Reject Access"}
        successButtonName={"Ok"}
        rejectButtonName={"Cancel"}
        onClickSuccess={handleConfirmRejectAccess}
        onClickReject={handleCancelRejectAccess}
        onConfirm={handleConfirmRejectAccess}
        actionButtonStyle={"continuous"}
      >
        <Stack spacing={1.2}>
          <DialogContentText>
            Are you sure you want to reject access?
          </DialogContentText>
          <Box>
            <CustomTextFieldN
              size={"small"}
              placeholder={"Reason to reject access*"}
              type={"text"}
              value={reasonToRejectAccess}
              setValue={setReasonToRejectAccess}
              // valueError={assemblyNoError}
              setValueError={() => null}
              variant={"standard"}
              txtFldStyle={styles.txtStyle}
            />
          </Box>
        </Stack>
      </CustomDialogBoxV2>
      <Dialog open={openForwardApproveAccessDialog}>
        <DialogTitle>Forward Access For Approval</DialogTitle>
        <Divider />
        <DialogContent>
          <Stack spacing={1.2}>
            {selectedRowData?.page_details?.length > 0 && (
              <Accordion style={{ marginBottom: "10px" }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h6" fontWeight="bold">
                    Pages
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container spacing={2}>
                    {selectedRowData?.page_details?.map((page, index) => (
                      <Grid item xs={12} key={index}>
                        <Box display="flex" alignItems="center">
                          {page?.page_name || "-"}
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </AccordionDetails>
              </Accordion>
            )}

            {/* Render Requested Feature Access */}
            {selectedRowData?.feature_details?.length > 0 && (
              <Accordion style={{ marginBottom: "10px" }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h6" fontWeight="bold">
                    Features
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {Object.entries(
                    selectedRowData?.feature_details.reduce((acc, feature) => {
                      if (!acc[feature?.feature_name])
                        acc[feature?.feature_name] = [];
                      acc[feature?.feature_name].push(feature);
                      return acc;
                    }, {}),
                  ).map(([featureName, featureGroup], index) => (
                    <Accordion
                      key={index}
                      style={{ marginBottom: "8px", marginLeft: "8px" }}
                    >
                      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography variant="body1" gutterBottom>
                          {featureName}
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid container spacing={2}>
                          {featureGroup.map((detail, index1) => {
                            if (!detail || typeof detail !== "object")
                              return null;
                            return (
                              <Grid item xs={12} key={index1}>
                                <Box display="flex" alignItems="center">
                                  {detail?.description || "-"}
                                </Box>
                              </Grid>
                            );
                          })}
                        </Grid>
                      </AccordionDetails>
                    </Accordion>
                  ))}
                </AccordionDetails>
              </Accordion>
            )}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ ...appTheme.commonBtnStyle }}
            color="error"
            variant="contained"
            onClick={() => handleCloseApproveAccessDialog()}
            startIcon={<CloseIcon />}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default ProjectAccess;

// Styles
const styles = {
  spContainer: {
    display: "flex",
    justifyContent: "center", // ⬅️ Horizontally center
    alignItems: "center", // ⬅️ Vertically center (optional)
    width: "100%", // ⬅️ Ensures it spans full width
    // marginBottom: "1rem", // or `mb: 4` if using `sx`
    // marginTop: "0.5rem", // or `mt: 1`
  },

  searchSelectTextField: {
    width: { xs: "100px", sm: "140px", md: "180px" },
    fontSize: { xs: "0.7rem", sm: "0.8rem" },
    borderRadius: "0",
    "& .MuiInputBase-input": {
      color: "#000000",
    },

    // ✅ Add this fix
    "& input:-webkit-autofill": {
      WebkitTextFillColor: "#000000",
      WebkitBoxShadow: "0 0 0px 1000px white inset",
      transition: "background-color 5000s ease-in-out 0s",
      transitionDelay: "9999s",
    },

    "& .MuiOutlinedInput-root": {
      height: "32px",
      "& fieldset": { borderColor: "#D0D0CE", borderRadius: "0px" },
      "&:hover fieldset": { borderColor: "#D0D0CE" },
      "&.Mui-focused fieldset": { borderColor: "#000000" },
      "&.Mui-disabled fieldset": { borderColor: "#D0D0CE" },
      "&.Mui-error fieldset": { borderColor: "#e53935" },

      "&:hover .MuiInputBase-input::placeholder": { color: "#848587" },
      "&.Mui-focused .MuiInputBase-input::placeholder": { color: "#232323" },
    },
    "& .MuiInputBase-input, & .MuiSelect-select": {
      color: "#000000 !important",
      WebkitTextFillColor: "#000000 !important",
    },

    "& .MuiSelect-icon": {
      color: "#000000",
    },

    "& .MuiInputLabel-root": {
      color: "#000",
      fontSize: "0.9rem",
      "&.Mui-error": { color: "#e53935" },
      "&.Mui-disabled": { color: "#bdbdbd" },
    },

    "& .MuiInputBase-input::placeholder": {
      color: "#999",
      opacity: 1,
    },

    "& .MuiFormHelperText-root.Mui-error": {
      color: "#e53935",
      fontSize: "0.8rem",
      marginLeft: 0,
      marginTop: "4px",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "black",
    },
  },

  tabsContainer: {
    display: "flex",
  },
};
